module.exports = __webpack_public_path__ + "img/vibrant_red.6598070.png";